/**
 * @fileoverview Componente responsável por exibir os logs de execução do fluxo.
 */

import React from "react";
import {
  Activity, AlertCircle, CheckCircle2, Clock, ChevronUp, ChevronDown,
} from "lucide-react";

/**
 * Painel de logs de execucao do workflow.
 *
 * Props:
 * - classes: makeStyles classes
 * - logPanelOpen: boolean
 * - setLogPanelOpen: function
 * - executionLogs: array of log entries
 * - nodes: current react-flow nodes (for label lookup)
 */
var LogPanel = function (props) {
  var classes = props.classes;
  var logPanelOpen = props.logPanelOpen;
  var setLogPanelOpen = props.setLogPanelOpen;
  var executionLogs = props.executionLogs;
  var nodes = props.nodes;
  // leftOffset: permite que o painel acompanhe a largura da sidebar
  // redimensionável. Fallback 280 (largura + handle) pra manter compat.
  var leftOffset = typeof props.leftOffset === "number" ? props.leftOffset : 280;

  return (
    <div
      ref={props.panelRef}
      className={classes.logPanel}
      style={{ height: logPanelOpen ? 220 : 36, left: leftOffset }}
    >
      <div
        className={classes.logPanelHeader}
        onClick={function () { setLogPanelOpen(function (p) { return !p; }); }}
      >
        <div className={classes.logPanelTitle}>
          <Activity size={14} />
          Execucoes
          {executionLogs.length > 0 && (
            <span className={classes.logPanelBadge}>{executionLogs.length}</span>
          )}
        </div>
        {logPanelOpen ? <ChevronDown size={14} /> : <ChevronUp size={14} />}
      </div>
      {logPanelOpen && (
        <div className={classes.logPanelBody}>
          {executionLogs.length === 0 && (
            <div className={classes.logEmpty}>
              Nenhuma execucao registrada. Ative o fluxo e envie uma mensagem para testar.
            </div>
          )}
          {executionLogs.map(function (log) {
            var time = new Date(log.timestamp);
            var timeStr = time.getHours().toString().padStart(2, "0") + ":" +
              time.getMinutes().toString().padStart(2, "0") + ":" +
              time.getSeconds().toString().padStart(2, "0");

            var StatusIcon = log.status === "running" ? Clock
              : log.status === "completed" ? CheckCircle2
              : AlertCircle;

            var statusColor = log.status === "running" ? "#f59e0b"
              : log.status === "completed" ? "#22c55e"
              : "#ef4444";

            var statusClass = log.status === "running" ? classes.logStatusRunning
              : log.status === "completed" ? classes.logStatusCompleted
              : classes.logStatusError;

            var nodeMatch = nodes.find(function (n) { return n.id === log.nodeId; });
            var nodeLabel = nodeMatch ? nodeMatch.data.label : log.nodeId;

            return (
              <div key={log.id} className={classes.logEntry}>
                <span className={classes.logEntryIcon}>
                  <StatusIcon size={13} color={statusColor} />
                </span>
                <span className={classes.logEntryTime}>{timeStr}</span>
                <span className={classes.logEntryNode}>{nodeLabel}</span>
                <span className={classes.logEntryStatus + " " + statusClass}>
                  {log.status === "running" ? "executando..." : log.status === "completed" ? "concluido" : "erro"}
                </span>
                {log.details && log.details.latencyMs && (
                  <span style={{ opacity: 0.5, fontSize: 11 }}>{log.details.latencyMs}ms</span>
                )}
                {log.details && log.details.error && (
                  <span style={{ color: "#ef4444", fontSize: 11 }}>{log.details.error}</span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LogPanel;
